import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Movie, TVShow, WatchlistItem } from "../../types";

interface MediaState {
  trendingMovies: Movie[];
  trendingShows: TVShow[];
  watchlist: {
    movies: WatchlistItem[];
    shows: WatchlistItem[];
  };
  favorites: (Movie | TVShow)[];
  movies: WatchlistItem[];
  shows: WatchlistItem[];
  loading: boolean;
  error: string | null;
}

const initialState: MediaState = {
  trendingMovies: [],
  trendingShows: [],
  watchlist: {
    movies: [],
    shows: [],
  },
  favorites: [],
  movies: [],
  shows: [],
  loading: false,
  error: null,
};

const mediaSlice = createSlice({
  name: "media",
  initialState,
  reducers: {
    setTrendingMovies: (state, action: PayloadAction<Movie[]>) => {
      state.trendingMovies = action.payload;
    },
    setTrendingShows: (state, action: PayloadAction<TVShow[]>) => {
      state.trendingShows = action.payload;
    },
    setWatchlist: (
      state,
      action: PayloadAction<{ movies: WatchlistItem[]; shows: WatchlistItem[] }>
    ) => {
      state.watchlist = action.payload;
    },
    setFavorites: (state, action: PayloadAction<(Movie | TVShow)[]>) => {
      state.favorites = action.payload;
    },
    toggleMovieWatchlist: (state, action: PayloadAction<number>) => {
      const movieId = action.payload;
      const movieIndex = state.watchlist.movies.findIndex(
        (m) => m.id === movieId
      );

      if (movieIndex === -1) {
        state.watchlist.movies.push({
          id: movieId,
          watchLater: false,
          addedAt: Date.now(),
        });
      } else {
        state.watchlist.movies.splice(movieIndex, 1);
      }
    },
    toggleShowWatchlist: (state, action: PayloadAction<number>) => {
      const showId = action.payload;
      const showIndex = state.watchlist.shows.findIndex((s) => s.id === showId);

      if (showIndex === -1) {
        state.watchlist.shows.push({
          id: showId,
          watchLater: false,
          addedAt: Date.now(),
        });
      } else {
        state.watchlist.shows.splice(showIndex, 1);
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const {
  setTrendingMovies,
  setTrendingShows,
  setWatchlist,
  setFavorites,
  toggleMovieWatchlist,
  toggleShowWatchlist,
  setLoading,
  setError,
} = mediaSlice.actions;

export default mediaSlice.reducer;
